const API = 'https://snp-tasks-api.attsnpit.workers.dev';

async function get(path) {
  const res = await fetch(`${API}${path}`);
  return res.json();
}

async function post(path, body) {
  const res = await fetch(`${API}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return res.json();
}

export const api = {
  // Tasks
  getTasks: () => get('/tasks'),
  saveTask: (task) => post('/tasks/save', task),
  deleteTask: (id) => post('/tasks/delete', { id }),
  seedTasks: (tasks, nextId) => post('/tasks/seed', { tasks, nextId }),

  // Shopping
  getShopping: () => get('/shopping'),
  saveShopItem: (item) => post('/shopping/save', item),
  deleteShopItem: (id) => post('/shopping/delete', { id }),

  // Log
  getLog: () => get('/log'),
  saveLogEntry: (entry) => post('/log/save', entry),
  deleteLogEntry: (id) => post('/log/delete', { id }),

  // Today
  getToday: (person, date) => get(`/today?person=${encodeURIComponent(person)}&date=${date}`),
  saveTodayItem: (item) => post('/today/save', item),
  deleteTodayItem: (id) => post('/today/delete', { id }),

  // Incidents
  getIncidents: (trackerId) => get(`/incidents?trackerId=${trackerId}`),
  saveIncident: (inc) => post('/incidents/save', inc),
  deleteIncident: (id) => post('/incidents/delete', { id }),

  // Calendar
  getCalendar: (from, to) => get(`/calendar?from=${from}&to=${to}`),
  saveCalendarEvent: (event, shifts) => post('/calendar/save', { event, shifts }),
  deleteCalendarEvent: (id) => post('/calendar/delete', { id }),

  // Bulletins
  getBulletins: (person) => get(`/bulletins?person=${encodeURIComponent(person)}`),
  getAllBulletins: () => get('/bulletins/all'),
  saveBulletin: (b) => post('/bulletins/save', b),
  ackBulletin: (bulletin_id, user) => post('/bulletins/ack', { bulletin_id, user }),
  deleteBulletin: (id) => post('/bulletins/delete', { id }),
};
